export default __webpack_public_path__ + "static/media/49t.b8963f13.jpg";